<template>
    <form id="tenat-form" method="POST" @submit.prevent="submit">
        <div v-if="isMultipleTenants">
            <jet-label for="tenant" value="Select Tenant" />
            <select name="tenant_id" id="tenant" class="mt-1 block w-full" v-model="formAction.tenant_id"
                cchange="chooseTenant" required>
                <option value="">Select Tenant</option>
                <option v-for="tenant in tenants" :value="tenant.id">{{ tenant.name }}</option>
            </select>
        </div>
        <div v-else>
            THIS STATE AUTO REDIRECTS TO TENANT PORTAL
        </div>



        <jet-input id="email" name="email" type="hidden" class="mt-1 block w-full" v-model="formAction.email" />

        <jet-input id="password" name="password" type="hidden" class="mt-1 block w-full" v-model="formAction.password"
            autocomplete="current-password" />

        <div class="flex items-center justify-center mt-4">

            <jet-button class="ml-4" :class="{ 'opacity-25': formAction.processing }" :disabled="formAction.processing">
                continue
            </jet-button>
        </div>
    </form>
</template>

<script>
import JetLabel from "@/Jetstream/Label";
import JetInput from "@/Jetstream/Input";
import JetButton from "@/Jetstream/Button";

export default {
    components: {
        JetLabel,
        JetInput,
        JetButton,
    },
    props: {

        form: {
            type: Object,
            required: true,
        },
        tenants: {
            type: Array,
            required: true,
        },
        isMultipleTenants: {
            type: Boolean,
            required: true,
        },
        selectedTenant: {
            type: [String, Number],
            default: null,
        },
    },
    data() {
        return {
            tenantSelection: this.selectedTenant, // Local property for v-model
            formAction: this.$inertia.form({
                email: this.form.email,
                password: this.form.password,
                tenant_id: this.selectedTenant
            })

        };
    },
    methods: {


        chooseTenant() {
            // axios.post(route('universal.tenant.redirect'), {
            //     email: this.form.email,
            //     password: this.form.password,
            //     tenant_id: this.tenantSelection
            // }).then((response) => {
            //     // if (response.data.status === "success") {
            //     this.formAction = response.data.redirect_url;
            //     //     console.log('response', response.data.redirect_url);

            //     // }
            // }).catch(error => {
            //     if (error.response && error.response.data && error.response.data.message) {
            //         console.log(error.response.data.message);
            //         this.form.errors.password = [error.response.data.message][0];
            //     } else {
            //         this.form.errors.password = ["Something went wrong, please try again later"];
            //     }
            // });
        },

        submit() {
            console.log('formAction', this.formAction.values);

            // axios.post(this.route("universal.tenant.redirect"), this.formAction.value).then((response) => {
            //     if (response.data.status === "success") {
            //         this.$emit("next", {
            //             step: 3,
            //         });
            //     } else {
            //         this.form.reset('password');
            //     }
            // }).catch(error => {

            //     if (error.response && error.response.data && error.response.data.message) {
            //         console.log(error.response.data.message);
            //         this.form.errors.password = [error.response.data.message][0];

            //     } else {
            //         this.form.errors.password = ["Something went wrong, please try again later"];
            //     }
            //     this.form.reset('password');
            // });
            this.formAction.post(this.route("universal.tenant.redirect"), {
                onSuccess: () => {
                    // console.log('response', response);
                    // this.$toast.success("Login Successfully!");
                },
            });
        }
    },
};
</script>

<style scoped>
.validation_error_msg {
    font-weight: 400;
    margin: 6px 0 0 !important;
    color: red;
}
</style>
